import { Link } from "react-router-dom";
import { BUSINESS_INFO } from "@/data/company";
import dchainConnectMark from "@/assets/brand/dchain-connect-mark.svg";

export function Footer() {
  return (
    <footer className="border-line-alternative border-t px-6 py-12">
      <div className="mx-auto flex max-w-layout flex-col gap-6">
        <div className="flex items-center gap-2">
          <img src={dchainConnectMark} alt="" width="34" height="28" className="h-7 w-auto" />
          <span className="wds-label-1 font-semibold text-label-strong">디체인커넥트</span>
        </div>
        <dl className="flex flex-wrap gap-x-2 gap-y-1">
          {BUSINESS_INFO.map((row, i) => (
            <div className="flex gap-1" key={row.label}>
              <dt className="wds-caption-1 text-label-assistive">{row.label}</dt>
              <dd className="wds-caption-1 text-label-assistive">{row.value}</dd>
              {i < BUSINESS_INFO.length - 1 && <span className="text-label-assistive">·</span>}
            </div>
          ))}
        </dl>
        <p className="wds-caption-1 text-label-assistive">
          직접 만들어 운영해온 걸로 증명하고, 맡겨주시면 운영까지 함께합니다.
        </p>
        <Link to="/inquiries" className="wds-caption-1 w-fit text-label-neutral underline underline-offset-4">
          문의 현황 보기
        </Link>
        <p className="wds-caption-1 text-label-assistive">
          © 2026 주식회사 디체인커넥트. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
